/**
 * Brand tokens — the single source of truth for the Last Seen marketing site.
 *
 * The redesign (coral/cream palette, Space Grotesk + Plus Jakarta Sans) is
 * highly custom, so the exact color/type/spacing values live here rather than
 * being spread across components. MUI's theme (see themeConfig.ts) is seeded
 * from these same tokens so that MUI components (Button, TextField, …) inherit
 * the brand automatically.
 */

export const brandColors = {
  // Backgrounds
  cream: '#F3EFE9',
  creamLight: '#FBF5EF',
  coral: '#E9756A',
  nearBlack: '#1A1714',
  nearBlack2: '#1F1D1B',
  phoneBody: '#0E0D0C',

  // Accents / text
  coralText: '#D85F53', // coral accent on cream
  coralAccentLight: '#F08B7F', // headline span on dark CTA
  textMuted: '#6F6862', // body text on cream
  legalBody: '#46403A', // legal reading copy
  onCoralHeading: '#2A1310', // headlines on coral
  onCoralBody: '#3A1A15', // body on coral
  footerText: '#C9C2BA',
  footerMuted: '#8A8279',

  // Hairlines
  hairline: 'rgba(31,29,27,0.08)',
} as const

export const brandFonts = {
  heading: "'Space Grotesk', sans-serif",
  body: "'Plus Jakarta Sans', sans-serif",
} as const

export const brandLayout = {
  maxWidth: 1320,
  padX: 64,
  padXMobile: 28,
  rowGap: 88,
  /** Responsive breakpoint (px). Matches MUI's default `md`. */
  breakpoint: 900,
} as const
